import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/mute.svg';

export const IconMute = createIconComponent(Icon);
